import React from "react";
import { useAppTranslation } from "../i18n/useAppTranslation";
import { AlteredKind, alteredLabelKey } from "../utils/statModifiers";

// Small art shown at the start of the label, per theme.
export const ALTERED_THEME_ICONS: Record<string, string> = {
  halloween: "/assets/images/events/halloween-magic.png",
};

type Props = {
  theme?: string;
  kind: AlteredKind;
  // Which edge of the (position: relative) image or card the band sits on.
  placement?: "top" | "bottom";
  className?: string;
  style?: React.CSSProperties;
};

// A slim band over a troop or item image that says an event modifier changed it.
// Renders nothing for an unknown theme or when no modifier runs.
const AlteredLabel = ({
  theme,
  kind,
  placement = "bottom",
  className,
  style,
}: Props) => {
  const { t } = useAppTranslation(["barracks"]);
  const key = alteredLabelKey(theme, kind);
  if (!key) return null;
  const normalized = theme!.toLowerCase();
  const icon = ALTERED_THEME_ICONS[normalized];
  return (
    <div
      role="note"
      style={style}
      className={
        `altered-label altered-label--${placement} altered-label--${normalized}` +
        (className ? " " + className : "")
      }
    >
      {icon && (
        <img
          className="altered-label__icon"
          src={icon}
          width={18}
          height={18}
          alt=""
        />
      )}
      <span className="altered-label__text">{t(key)}</span>
    </div>
  );
};

export default AlteredLabel;
